import { render, staticRenderFns } from "./ReportMovemtStock.vue?vue&type=template&id=60ba1c58&scoped=true"
import script from "./ReportMovemtStock.vue?vue&type=script&lang=js"
export * from "./ReportMovemtStock.vue?vue&type=script&lang=js"


/* normalize component */
import normalizer from "!../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "60ba1c58",
  null
  
)

export default component.exports